// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__topbar__wfzOo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.index-module__header-container__w1LND {
  padding: 0px 20px !important;
}
.index-module__user-profile__Go7LY {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.index-module__img-style__jU4sT {
  height: 40px;
  width: 170px;
}
.index-module__company-logo__xH__j {
  display: none !important;
}
.index-module__header-text-container__aVhvm {
  font-size: 27px;
  font-weight: 600;
}
/* media queries with smaller max-width have preference/overrites styles with higher max-width */
/* tablet  */
@media only screen and (min-width: 768px) and (max-width: 1280px) {
  .index-module__img-style__jU4sT {
    height: 35px;
    width: 140px;
  }
}
/* large mobile */
@media only screen and (min-width: 600px) and (max-width: 768px) {
  .index-module__img-style__jU4sT {
    height: 23px;
    width: 105px;
  }
  .index-module__company-logo__xH__j {
    display: block !important;
  }
}
/* small mobile */
@media only screen and (max-width: 600px) {
  .index-module__img-style__jU4sT {
    height: 23px;
    width: 70px;
  }
  .index-module__company-logo__xH__j {
    display: none !important;
  }
}
@media only screen and (max-width: 1300px) {
  .index-module__header-text-container__aVhvm {
    font-size: 22px;
    font-weight: 600;
  }
}
@media only screen and (max-width: 768px) {
  .index-module__header-text-container__aVhvm {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/TopBar/index.module.less"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,gGAAgG;AAChG,YAAY;AACZ;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF;AACA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;AACF;AACA,iBAAiB;AACjB;EACE;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.header-container {\n  padding: 0px 20px !important;\n}\n.user-profile {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n}\n.img-style {\n  height: 40px;\n  width: 170px;\n}\n.company-logo {\n  display: none !important;\n}\n.header-text-container {\n  font-size: 27px;\n  font-weight: 600;\n}\n/* media queries with smaller max-width have preference/overrites styles with higher max-width */\n/* tablet  */\n@media only screen and (min-width: 768px) and (max-width: 1280px) {\n  .img-style {\n    height: 35px;\n    width: 140px;\n  }\n}\n/* large mobile */\n@media only screen and (min-width: 600px) and (max-width: 768px) {\n  .img-style {\n    height: 23px;\n    width: 105px;\n  }\n  .company-logo {\n    display: block !important;\n  }\n}\n/* small mobile */\n@media only screen and (max-width: 600px) {\n  .img-style {\n    height: 23px;\n    width: 70px;\n  }\n  .company-logo {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 1300px) {\n  .header-text-container {\n    font-size: 22px;\n    font-weight: 600;\n  }\n}\n@media only screen and (max-width: 768px) {\n  .header-text-container {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topbar": `index-module__topbar__wfzOo`,
	"header-container": `index-module__header-container__w1LND`,
	"user-profile": `index-module__user-profile__Go7LY`,
	"img-style": `index-module__img-style__jU4sT`,
	"company-logo": `index-module__company-logo__xH__j`,
	"header-text-container": `index-module__header-text-container__aVhvm`
};
export default ___CSS_LOADER_EXPORT___;
